"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_superwifi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "35a64de8-13c4-4689-8079-65417a79d45c",
    "data-name": "Apps_ic",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("title", null, "superwifi-mid"), /*#__PURE__*/React.createElement("g", {
    id: "7bef0a95-9867-43a1-805e-40799f7a8bc8",
    "data-name": "Apps_ic_hi"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "600711fb-a9d6-44d7-b99f-1417d674b2f8",
    "data-name": "Bounding Box",
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.57,41.64H55.43A7.75,7.75,0,0,0,49.89,44L20.25,74a7.79,7.79,0,0,0,0,11l70.2,71.16a7.79,7.79,0,0,0,11.1,0L171.75,85a7.79,7.79,0,0,0,0-11L142.11,44A7.75,7.75,0,0,0,136.57,41.64Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "1a520d98-f866-4c9e-ab5e-2a3951549bd1",
    "data-name": "ef2ad056-d8fc-4e13-85aa-df4f45d95617",
    d: "M44.52,81.76a72.77,72.77,0,0,1,102.91-.05h0l0,.05",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "2a16a936-195d-4c9e-9997-ad354f64cfe2",
    "data-name": "6b1a2532-e4b8-4581-8047-403aa5a27214",
    d: "M59.23,97.34a52,52,0,0,1,73.53,0h0",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "fbec5d65-38a1-4124-aec1-6a13ad02f45f",
    "data-name": "37ac030d-e655-40e7-8b0e-33210acff01d",
    d: "M74.63,112.63a30.23,30.23,0,0,1,42.74,0h0",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 130.87,
    r: 2.71,
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 130.87,
    r: 1.69,
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 130.87,
    r: 0.68,
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.1
  })));
}

var _default = ic_superwifi;
exports.default = _default;